// src/components/ObraSelect.js
import React from 'react';
import { Select, Typography } from 'antd';

function ObraSelect({ selectedObra, handleObraChange, obras }) {
  return (
    <div style={{ maxWidth: '400px', margin: '0 auto', textAlign: 'center' }}>
      <Typography.Title level={5}>Seleccionar Obra</Typography.Title>
      <Select
        placeholder="Selecciona una obra"
        value={selectedObra ? selectedObra.id : undefined}
        onChange={(value) => {
          const obraSeleccionada = obras.find((obra) => obra.id === value);
          handleObraChange(obraSeleccionada);
        }}
        style={{ width: '100%', marginTop: '8px' }}
      >
        {obras.map((obra) => (
          <Select.Option key={obra.id} value={obra.id}>
            {obra.nombre_obra}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
}

export default ObraSelect;
